module.exports = __webpack_public_path__ + "img/serviceGuide-center-1.0085862.png";